/** 
 * Toggle card front/back (for each resGrid)
 * Add listener for more info flipper
 **/

import { dId, dQS, dQSa, logger } from "./utils";
import { call_detail } from "./results_functions";

declare const URL_BASE: string;

function step1CardListener() {

  const detail = dQSa(".af-car-grid span[data-details]");
  const target = dQSa(".af-car-grid span[data-toggle]");
	// Cannot change this without changing the fetched HTML
  const cardinfo_open_target = dQSa(".despleg_btn");
  const cardinfo_close_target = dQSa(".despleg-close");


	logger("Add toggle listener to each card");

	target.forEach((elem) => {

		// Remove previous listeners:
		elem.removeEventListener("click", (e) => { });

		// Add new listener:
		elem.addEventListener("click", (e) => {

			const id = (<HTMLElement>e.target).dataset.toggle;
			if (id === undefined) { return; }

			logger("Flip card " + id, "log");
			toggleFlip(id);

		});
	});



	logger("Add toggle listeners to each info panel");


	cardinfo_open_target.forEach((elem) => {

		// Add icon to each card:
		appendCardIcons(elem as HTMLElement);

		// Remove previous listeners:
		elem.removeEventListener("click", (e) => { });

		// Add new listener:
		elem.addEventListener("click", (e) => {

			const id = (<HTMLElement>e.target).id;
			if (id === undefined) { return; }

			// Hide "close section" button on first load (d_but_id_i):
			let close_sec_id = "desp_close_" + id.split("_")[2];
			(<HTMLElement>dId(close_sec_id)).style.display="none";

			logger("Open More Info card " + id, "log");
			openCardInfo(id);

		});
	});


  cardinfo_close_target.forEach((elem) => {

		// Remove previous listeners:
		elem.removeEventListener("click", (e) => { });

		// Add new listener:
		elem.addEventListener("click", (e) => {

			const id = (<HTMLElement>e.target).id;
			if (id === undefined) { return; }

			logger("Close More Info card " + id, "log");
			closeCardInfo(id);

		});
	});


  logger("Add step 2 listeners to each card");
  detail.forEach((elem) => {

		// Remove previous listeners:
		elem.removeEventListener("click", (e) => { });

		// Add new listener:
		elem.addEventListener("click", (e) => {

			const id = (<HTMLElement>e.target).dataset.details;

      logger("Load information for vehicle #" + id, "log");

			if (id === undefined) { return; }

			call_detail( parseInt(id) );

		});

  });

}


function toggleFlip( i:string ) {

	logger("Toggle Flip " + i, "log");
	
	const target = <HTMLElement>dQS("#cgn_" + i);
	
	if (target === null) { return; }
	
	// Hide backside if not flipped yet: 
	if (!target.classList.contains("flipped")) {

		// Reset the descriptions if showing: 
	  closeCardInfo("desp_close_" + i);
	
	}
	
	
	// then do rotate
	target.classList.toggle("flipped");

	try {
		// @ts-ignore
		gtag('event', 'view_moreinfo', {
			'value': 'toggle',
		  });
	} catch(e){
		logger("No GA register Toggle", "log");	
	}
	
}

// Append Plus icon not present in HTML: 
function appendCardIcons(elem:HTMLElement) {

	logger("Append Card Icons", "log");
	
	const icon = document.createElement("span");
	const img = document.createElement("img");
	img.src = URL_BASE + "img/search.svg";
	img.alt = "";
	icon.appendChild(img);
	elem.appendChild(icon);
	
}

//
function openCardInfo(id:string) {

	logger("Open Card Info List" + id, "log");
	
  const target_info_id = id.replace("_btn_", "_des_");
  const target_parent_id = "cgn_" + id.replace("d_btn_", "").split("_")[0];
  const buttons = dQSa(".despleg-btn");
  
  if (!dId(target_info_id) || !dId(target_parent_id)) { return; }

  // Show the selected info panel section: 
  ( <HTMLElement>dId(target_info_id) ).style.display="block";

  // show close subcontent button:
  ( <HTMLElement>dQS("#" + target_parent_id + " .despleg-close") ).style.display="block";

  // Hide all info buttons: 
  buttons.forEach((elem) => {
    (<HTMLElement>elem).style.display="none";
  });

}
	

function closeCardInfo(id:string) {

  logger("Close Card Info " + id, "log");
		
  const target_info_id = id.replace("desp_close_", "cgn_");
  const buttons = dQSa("#" + target_info_id + " .despleg-btn");
  const descs = dQSa("#" + target_info_id + " .despleg_desc");

  // Reset the descriptions if showing: 
  buttons.forEach((elem) => {
    (<HTMLElement>elem).style.display = "block";
  });

  // Reset the descriptions if showing: 
  descs.forEach((elem) => {
    (<HTMLElement>elem).style.display = "none";
  });

	(<HTMLElement>dId(id)).style.display="none";
	
}


  export { step1CardListener };